import { ArrowRight, MessageCircle, ClipboardCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PROJECT_CHOICES, PROJECT_DELIVERABLES } from "../../data/site";
import { scrollToId, waLink } from "../../lib/contact";

export const FinalProject = () => (
  <section data-testid="final-project-section" className="py-24 sm:py-28 bg-background bg-grid-light">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        overline="The Capstone"
        title="Build One Practical Business Project"
        sub="Students explore all five business models during the program. For the final project, every student selects one — and builds a complete execution plan."
      />
      <div className="mt-14 grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="h-full bg-navy rounded-2xl p-7 sm:p-9 relative overflow-hidden">
            <div className="absolute inset-0 bg-grid-navy" />
            <div className="relative">
              <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-cyanx">Choose Your Model</p>
              <ul className="mt-6 space-y-4">
                {PROJECT_CHOICES.map((c, i) => (
                  <li key={c} data-testid={`project-choice-${i + 1}`} className="flex items-center gap-4 group">
                    <span className="w-9 h-9 rounded-lg bg-electric/25 border border-electric/30 flex items-center justify-center font-display font-bold text-cyanx text-sm shrink-0 group-hover:bg-electric group-hover:text-white transition-colors">
                      {i + 1}
                    </span>
                    <span className="font-display font-semibold text-white text-base">{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="h-full bg-white border border-slate-200/80 rounded-2xl p-7 sm:p-9">
            <p className="flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.25em] text-electric">
              <ClipboardCheck size={15} /> The Student Will Then Prepare
            </p>
            <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {PROJECT_DELIVERABLES.map((d, i) => (
                <li key={d} data-testid={`project-deliverable-${i + 1}`} className="flex items-start gap-2.5 text-sm text-slate-600">
                  <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-electric shrink-0" />
                  {d}
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-wrap gap-4">
              <button
                data-testid="final-project-cta"
                onClick={() => scrollToId("contact")}
                className="group inline-flex items-center gap-2 bg-navy hover:bg-navy-800 text-white font-semibold text-sm rounded-full px-7 py-4 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-navy/25"
              >
                Book Free Counselling
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                data-testid="final-project-whatsapp"
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 border border-slate-300 hover:border-electric text-navy font-semibold text-sm rounded-full px-7 py-4 transition-colors"
              >
                <MessageCircle size={16} /> WhatsApp Admissions
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
